import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditRoomsForm = (strings: any, roomType: []): FormModel[] => {
  return [
    {
      label: strings.room_text_type,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'roomType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      options: roomType,
    },
    {
      label: strings.room_text_taxGroup,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.room_text_taxGroup,
      field: 'taxGroup',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      isMulti: false,
      isClearable: false,
    },
    {
      label: strings.room_text_price,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'pricePerDay',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
    },
    {
      label: `${strings.room_text_serviceCharge} (%)`,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'serviceChargePercentage',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat, max: 100 }],
      responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: false,
    },
  ];
};
